import MAYOCLINIC from '../../images/homepage/mayoClinic.png';
import NYUHEALTH from '../../images/homepage/nyuHealth.jpeg';
import UCLAHEALTH from '../../images/homepage/uclaHealth.png';
import HCAHEALTH from '../../images/homepage/hcaHealth.png';
import PROVIDENCEHEALTH from '../../images/homepage/providenceHealth.png';
import UPMCHEALTH from '../../images/homepage/upmcHealth.png';
import CVSHEALTH from '../../images/homepage/cvsHealth.png';
import UNITEDHEALTHGROUP from '../../images/homepage/unitedHealth.png';
import PFIZER from '../../images/homepage/pfizer.svg.png';

const CompanyCards = () => {
    const companies = [
      { logo: MAYOCLINIC, position: 'Registered Nurse', company: 'Mayo Clinic' },
      { logo: CVSHEALTH, position: 'Medical Assistant', company: 'CVS Health' },
      { logo: NYUHEALTH, position: 'New Grad RN', company: 'NYU Health' },
      { logo: PROVIDENCEHEALTH, position: 'Certified Nursing Assistant', company: 'Providence' },
      { logo: UCLAHEALTH, position: 'ICU Nurse', company: 'UCLA Health' },
      { logo: HCAHEALTH, position: 'Certified Nursing Assistant', company: 'HCA Healthcare' },
      { logo: PFIZER, position: 'Nurse Educator', company: 'Pfizer' },
      { logo: UNITEDHEALTHGROUP, position: 'Care Coordinator RN', company: 'United Health Group' },
      { logo: UPMCHEALTH, position: 'New Grad RN', company: 'UPMC Health' },
    ];
  
    return (
      <div className="company-card-grid">
        {companies.map((company, index) => (
          <div className="company-card" key={index}>
            <div className="card-top">
              <img src={company.logo} alt={`${company.company} Logo`} className="company-logo" />
            </div>
            <div className="card-content">
              <h3>{company.position}</h3>
              <a href="/login">
                <button className="card-button">Start Interview</button>
              </a>
            </div>
          </div>
        ))}
      </div>
    );
  };
  
  export default CompanyCards;